import { AppTracker } from '../model/appSettings.shared.model.js';
import { DataFlag } from '../model/dataFlag.shared.model.js';
import { Goal } from '../model/goal.model.js';
export const DEFAULT_DAILY_CHECKIN_SETTINGS = {
  [Goal.PERIMENOPAUSE]: {
    [AppTracker.SLEEP]: true,
    [AppTracker.PAIN]: [DataFlag.PAIN_VAGINAL, DataFlag.PAIN_SORE_NIPPLES, DataFlag.PAIN_BACKACHE, DataFlag.PAIN_HEADACHE],
    [AppTracker.SKIN]: [],
    [AppTracker.LIFESTYLE]: [DataFlag.LIFESTYLE_ALCOHOL, DataFlag.LIFESTYLE_CAFFEINE, DataFlag.LIFESTYLE_SUGAR, DataFlag.LIFESTYLE_HIGH_FAT_FOOD, DataFlag.LIFESTYLE_SMOKING, DataFlag.LIFESTYLE_STRESS, DataFlag.LIFESTYLE_THERAPY, DataFlag.LIFESTYLE_JOURNALING, DataFlag.LIFESTYLE_KEGEL_EXERCISE, DataFlag.LIFESTYLE_BREATHING_EXERCISE, DataFlag.LIFESTYLE_SUPPLEMENTS, DataFlag.LIFESTYLE_MINDFULNESS],
    [AppTracker.MOOD]: [DataFlag.MOOD_HAPPY, DataFlag.MOOD_CALM, DataFlag.MOOD_SWINGS, DataFlag.MOOD_IRRITABLE, DataFlag.MOOD_ANXIOUS, DataFlag.MOOD_SENSITIVE, DataFlag.MOOD_SAD, DataFlag.MOOD_UNFOCUSED, DataFlag.MOOD_SELF_CRITICAL, DataFlag.MOOD_CONFUSED, DataFlag.MOOD_ISOLATED, DataFlag.MOOD_FEELING_LOW],
    [AppTracker.LIBIDO]: true
  },
  [Goal.POSTPARTUM]: {
    [AppTracker.SLEEP]: true,
    [AppTracker.PAIN]: [DataFlag.PAIN_VAGINAL, DataFlag.PAIN_SORE_NIPPLES, DataFlag.PAIN_BACKACHE, DataFlag.PAIN_HEADACHE],
    [AppTracker.SKIN]: [],
    [AppTracker.LIFESTYLE]: [],
    [AppTracker.MOOD]: [],
    [AppTracker.LIBIDO]: false
  }
};